import styled from 'styled-components';
import { colorConstants } from '../../theme/mindly_constants';
import { isPlatform } from '@ionic/react';

type SupportButtonContainerProps = {
  isActive?: boolean;
  paddingBottomInPX?: number;
  paddingRightInPX?: number;
};

export const SupportButtonContainer = styled.button<SupportButtonContainerProps>`
  width: 50px;
  height: 50px;

  display: flex;
  align-items: center;
  justify-content: center;

  position: absolute;
  right: ${(props) => props.paddingRightInPX ?? 20}px;
  bottom: calc(env(safe-area-inset-bottom) + ${(props) => props.paddingBottomInPX ?? 20}px);

  background: #029cee;
  box-shadow: 0px 4.99984px 19.9994px rgba(0, 0, 0, 0.1);

  border-radius: 50%;

  cursor: pointer;

  transition: 200ms all;

  ion-icon {
    color: ${(props) => (props.isActive ? colorConstants.primaryColor : 'white')};
    width: 20px;
    height: 20px;
  }

  img {
    width: 45%;
  }

  &:active {
    background: #029cee;
  }
`;

export const SupportButtonMenu = styled.ul`
  padding: 0;
  margin: 0;
  position: absolute;
  right: ${isPlatform('hybrid') ? '17px' : '40px'};

  bottom: calc(env(safe-area-inset-bottom) + 90px);

  width: 194px;
  height: auto;

  background: #ffffff;

  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.12);

  display: flex;
  flex-direction: column;
  border-radius: 10px;

  transition: 200ms ease-out;

  .heading {
    border-radius: 10px 10px 0px 0px;
    padding: 12px 16px;
    color: #1d201f;

    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;

    list-style: none;

    background: #e9f7fb;
    cursor: default;
  }

  a {
    text-decoration: none;

    &:last-of-type {
      li {
        border-bottom: none;
        border-radius: 0px 0px 10px 10px;
      }
    }
  }

  a li {
    padding: 12px 16px;

    display: flex;
    align-items: center;
    gap: 10px;

    height: 44px;
    border-bottom: 1px solid #eeeeee;
    background-color: white;

    color: #1d201f;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 16px;

    list-style: none;

    cursor: pointer;

    &:hover {
      background: #e9f7fb;
    }
  }
`;
